window.updateElementById = function (id, newText) {
  const element = document.getElementById(id)
  if (element) {
    element.innerHTML = newText
  }
}

//ANCHOR COOKIE CONSTANT
const THEME_COOKIE_PREFIX = window.COOKIE_PREFIX
window.COOKIE_NAMING = function (name) {
  return THEME_COOKIE_PREFIX + '_' + name
}

const FUNCTIONAL_COOKIE_DURATION = window.COOKIE_DURATION.functional
const MARKETING_COOKIE_DURATION = window.COOKIE_DURATION.marketing

/*ANCHOR ID GENERATORS
 */

//It create a unique id in sha256, with 16 length
window.ID_STRING = {
  id() {
    let date = Date.now()
    const currentDateInSeconds = date.toString()
    const screenWidth = window.screen.width.toString()
    const screenHeight = window.screen.height.toString()
    const urlLength = window.location.href.length
    const randomValue = Math.floor(Math.random() * 1000) + 1
    return (
      currentDateInSeconds +
      screenWidth +
      screenHeight +
      urlLength +
      randomValue
    )
  },
  async hash(value) {
    const encoder = new TextEncoder()
    const data = encoder.encode(value)
    const hashBuffer = await crypto.subtle.digest('SHA-256', data)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const shortHashArray = hashArray.slice(0, 12)
    const base64Hash = btoa(String.fromCharCode(...shortHashArray))
    const cleanedHash = base64Hash.replace(/[^a-zA-Z0-9]/g, '0')
    return cleanedHash.slice(0, 16).padEnd(16, '0')
  },
  async create() {
    let id = await this.hash(this.id())
    //console.log(id)
    return id
  },
}
window.ID_NUMBER = {
  create() {
    const firstDigit = Math.floor(Math.random() * 9) + 1
    const remainingDigits = Math.floor(Math.random() * Math.pow(10, 14))
      .toString()
      .padStart(14, '0')
    return parseInt(firstDigit + remainingDigits)
  },
}

/*ANCHOR DEBUGGER LIBRARY
It create a method of this object (DS) that
is a console.log that is visualize only if a determinate cookie
(with the same name of the method) is present
 */

window.DS = {
  create(cookieName) {
    this[cookieName] = (...args) => {
      if (
        document.cookie
          .split(';')
          .some((item) => item.trim().startsWith(cookieName + '='))
      ) {
        console.log(cookieName, ...args)
      }
    }
  },
}

DS.create('cookieDebug')
/*
debugger di tutte le azioni native dei cookie
*/
DS.create('eventDebug')
/*
debugger di tutte le azioni native della libreria eventi sul document
*/
DS.create('dataLayerDebug')
/*
debugger di tutte le azioni del dataLayer
*/

/*ANCHOR GTM library*/
window.GTM_PUSH = async function (event) {
  window.dataLayer = window.dataLayer || []
  window.THEME_INFO = window.THEME_INFO || {}
  window.LOGGED_INFO = window.LOGGED_INFO || {}
  let eventIdString = await ID_STRING.create()
  let eventIdNumber = ID_NUMBER.create()
  let timestamp = Date.now()
  let eventObject = {
    themeInfo: THEME_INFO,
    userData: window.LOGGED_INFO,
    timestamp: timestamp,
    eventIdString: eventIdString,
    eventIdNumber: eventIdNumber,
    ...event,
  }
  dataLayer.push(eventObject)
  DS.dataLayerDebug('event', eventObject, 'dataLayer', dataLayer)
}

//ANCHOR EVENT LIBRARY
window.EMD = {
  emit(name, data) {
    const event = new CustomEvent(name, { detail: data })
    document.dispatchEvent(event)
    DS.eventDebug('EMD EMIT', name, data, event)
  },
  listen(name, action) {
    document.addEventListener(name, function (e) {
      action(e)
      DS.eventDebug('EMD LISTEN', name, e)
    })
  },
}

/*ANCHOR cookie library
various method of interact with cookie
 */

window.CM = {
  get(name, debug = true) {
    const cookies = document.cookie.split('; ')
    const cookie = cookies.find((row) => row.startsWith(`${name}=`))
    let result = cookie ? decodeURIComponent(cookie.split('=')[1]) : undefined
    if (debug) {
      DS.cookieDebug('get', name, result)
    }
    return result
  },

  getJson(name, debug = true) {
    const value = this.get(name, false)
    try {
      const parsed = JSON.parse(value)
      if (debug) {
        DS.cookieDebug('getJson', name + ' isJson', parsed)
      }

      return parsed
    } catch (e) {
      if (debug) {
        DS.cookieDebug('getJson', name + ' isNotJson', value)
      }

      return undefined
    }
  },

  getArray(names) {
    let result = names.map((name) => this.get(name, false))
    DS.cookieDebug('getArray', names, result)
    return result
  },

  getArrayJson(names) {
    let result = names.map((name) => {
      const rawValue = this.get(name, false)
      if (rawValue === undefined) {
        return undefined
      } else {
        try {
          return JSON.parse(rawValue)
        } catch {
          return rawValue
        }
      }
    })
    DS.cookieDebug('getArrayJson', names, result)
    return result
  },

  set(name, value, days = 0.1, type = 'normale') {
    if (days > 180) days = 180
    const expires = new Date(Date.now() + days * 86400000).toUTCString()
    document.cookie = `${name}=${encodeURIComponent(
      value
    )}; expires=${expires}; path=/`
    DS.cookieDebug('set ' + type, name, value)
  },

  setJson(name, object, days) {
    const value = JSON.stringify(object)
    this.set(name, value, days, 'json')
  },

  async setHash(name, value, days) {
    const encoder = new TextEncoder()
    const data = encoder.encode(value)
    const hashBuffer = await crypto.subtle.digest('SHA-256', data)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('')
    this.set(name, hashHex, days, 'hash')
  },

  delete(name, debug = true) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
    if (debug) {
      DS.cookieDebug('delete', name)
    }
  },

  deleteArray(names) {
    names.forEach((name) => this.delete(name, false))
    DS.cookieDebug('deleteArray', names)
  },

  contains(name, value, ifFn = undefined, elseFn = undefined) {
    let action = 'azione non compiuta'
    const cookieValue = this.get(name, false)
    if (cookieValue && cookieValue.includes(value)) {
      if (ifFn) {
        ifFn()
        action = 'azione compiuta'
      }
      DS.cookieDebug('contains', name, value, 'contains vero', action)
      return true
    } else {
      if (elseFn) {
        elseFn()
        action = 'azione compiuta'
      }
      DS.cookieDebug('contains', name, value, 'contains falso', action)
      return false
    }
  },

  trueJson(name, criteriaFn, ifFn = undefined, elseFn = undefined) {
    let action = 'azione non compiuta'
    const value = this.getJson(name, false)
    if (value !== undefined && criteriaFn(value)) {
      if (ifFn) {
        ifFn()
        action = 'azione compiuta'
      }
      DS.cookieDebug('trueJson', name, value, 'true', action)
      return true
    } else {
      if (elseFn) {
        elseFn()
        action = 'azione compiuta'
      }
      DS.cookieDebug('trueJson', name, value, 'falso', action)
      return false
    }
  },
  setFunctionalCookie(name, value) {
    this.set(COOKIE_NAMING(name), value, window.COOKIE_DURATION.functional)
  },
}

//ANCHOR sanitize library
// Assicura che LOGGED_INFO sia definito
window.LOGGED_INFO = window.LOGGED_INFO || {}
window.LOGGED_INFO.address = window.LOGGED_INFO.address || {}

window.CPI = {
  hash(value) {
    const encoder = new TextEncoder()
    const data = encoder.encode(value)
    return crypto.subtle.digest('SHA-256', data).then((hashBuffer) => {
      return Array.from(new Uint8Array(hashBuffer))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('')
    })
  },

  cleanEmail(email) {
    email = email.trim().toLowerCase().split('@')
    return email[1] === 'gmail.com' || email[1] === 'googlemail.com'
      ? email[0].replaceAll('.', '').split('+')[0] + '@' + email[1]
      : email[0].split('+')[0] + '@' + email[1]
  },

  hashEmail(email) {
    return this.hash(this.cleanEmail(email))
  },

  canProceedWithHashing() {
    const consentData = window.CM.getJson('bsnm_consent_native', false)
    return consentData && consentData.marketing === true
  },

  hashAndAssign(value, property, isEmail = false, address = false) {
    if (
      !value ||
      typeof value !== 'string' ||
      value.trim() === '' ||
      !this.canProceedWithHashing()
    ) {
      return Promise.resolve() // Restituisce una Promise risolta se il valore non è valido o se il consenso non è stato dato
    }

    const valueToHash = isEmail ? this.cleanEmail(value) : value
    if (!address) {
      return this.hash(valueToHash).then((hashResult) => {
        window.LOGGED_INFO[property] = hashResult
      })
    } else {
      return this.hash(valueToHash).then((hashResult) => {
        window.LOGGED_INFO.address[property] = hashResult
      })
    }
  },
}

//ANCHOR IUBENDA SHOPIFY CONSENT API BRIDGE
/* documentazione utile a riguardo
https://www.iubenda.com/it/help/145731-privacy-controls-and-cookie-solution-per-shopify-come-mostrare-il-cookie-banner-e-raccogliere-il-consenso-ai-cookie
https://developers.google.com/tag-platform/security/guides/consent?consentmode=advanced
IUB_CONSENT.update() is to put on iubenda callbacks 'onPreferenceExpressed', 
*/
window.iubendaShopifyBridge = function (prefs) {
  var isPrefEmpty = !prefs || Object.keys(prefs).length === 0
  var consent = isPrefEmpty ? _iub.cs.api.getPreferences() : prefs
  var shopifyPurposes = {
    analytics: [4, 's'],
    marketing: [5, 'adv'],
    preferences: [2, 3],
    sale_of_data: ['s', 'sh'],
  }
  var expressedConsent = {}
  Object.keys(shopifyPurposes).forEach(function (purposeItem) {
    var purposeExpressed = null
    shopifyPurposes[purposeItem].forEach((item) => {
      if (consent.purposes && typeof consent.purposes[item] === 'boolean') {
        purposeExpressed = consent.purposes[item]
      }
      if (
        consent.uspr &&
        typeof consent.uspr[item] === 'boolean' &&
        purposeExpressed !== false
      ) {
        purposeExpressed = consent.uspr[item]
      }
    })

    if (typeof purposeExpressed === 'boolean') {
      expressedConsent[purposeItem] = purposeExpressed
    }
  })
  CM.setJson(
    'bsnm_consent_native',
    expressedConsent,
    window.COOKIE_DURATION.functional
  )
  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    function (error) {
      if (error) {
        throw error
      }
      window.Shopify.customerPrivacy.setTrackingConsent(
        expressedConsent,
        function () {}
      )
    }
  )
}

//ANCHOR DATALAYER LIBRARY
class GtmDataExtractor {
  static extractData(className) {
    const container = document.querySelector(`.${className}`)
    if (!container) return []

    const items = container.querySelectorAll('.gtm-item')

    return Array.from(items).map((item) => {
      const attributes = item.attributes
      const gtmAttributes = {}

      Array.from(attributes).forEach((attr) => {
        if (attr.name.startsWith('data-gtm-')) {
          const attributeName = attr.name.replace('data-gtm-', '')
          let value = attr.value || null

          // Convert to number if applicable
          if (value && !isNaN(value.trim()) && value.trim() !== '') {
            value = parseFloat(value)
          }

          gtmAttributes[attributeName] = value
        }
      })

      return gtmAttributes
    })
  }

  static async sendViewEvent(className, event) {
    let items = this.extractData(className)
    let eventObject = { raw_data_items: items, ...event }
    await window.GTM_PUSH(eventObject)
  }
}

class ShopifyProductFetcher {
  constructor(accessToken, storeName) {
    this.accessToken = accessToken
    this.storeUrl = `https://${storeName}/api/2024-10/graphql.json`
  }
  async sendEvent(numericProductId, idVariant, event) {
    let item = await this.fetchProductById(numericProductId, idVariant)
    let eventObject = {
      ...event,
      raw_data_items: [item],
    }
    await window.GTM_PUSH(eventObject)
  }
  async fetchProductById(numericProductId, idVariant) {
    const productId = this.encodeId(numericProductId)

    const query = `
      query getProductById($id: ID!) {
        product(id: $id) {
          id
          title
          metafield(namespace: "custom", key: "gtm_info") {
            value
          }
          variants(first: 250) {
            edges {
              node {
                id
                sku
                selectedOptions {
                  name
                  value
                }
                priceV2 {
                  amount
                  currencyCode
                }
                compareAtPriceV2 {
                  amount
                  currencyCode
                }
                metafield(namespace: "omnibus", key: "bestPrice") {
                  value
                }
              }
            }
          }
        }
      }
    `

    const variables = { id: productId }

    try {
      const response = await fetch(this.storeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.accessToken,
        },
        body: JSON.stringify({ query, variables }),
      })

      const result = await response.json()
      const productData = result.data.product
      const selectedVariantEdge = productData.variants.edges.find(
        (variant) =>
          variant.node.id === `gid://shopify/ProductVariant/${idVariant}`
      )

      if (!selectedVariantEdge) {
        throw new Error('Variant not found')
      }

      const selectedVariant = selectedVariantEdge.node
      const price = parseFloat(selectedVariant.priceV2.amount)
      const compareAtPrice = selectedVariant.compareAtPriceV2
        ? parseFloat(selectedVariant.compareAtPriceV2.amount)
        : null
      const sizeOption =
        selectedVariant.selectedOptions.find(
          (option) => option.name === 'Size'
        ) ||
        selectedVariant.selectedOptions.find(
          (option) => option.name === 'Taille'
        )
      const sizeValue = sizeOption ? sizeOption.value : null
      const omnibusValue = selectedVariant.metafield?.value
        ? JSON.parse(selectedVariant.metafield.value).amount
        : null
      const omnibusAmount = omnibusValue ? parseFloat(omnibusValue) : null

      const product = {
        selectedvariant: 'yes',
        meta: productData.metafield?.value || null,
        price: price,
        compare: compareAtPrice,
        omnibus: omnibusAmount,
        sku: selectedVariant.sku || null,
        productid: numericProductId,
        variantid: idVariant,
        size: sizeValue,
        quantity: 1,
      }

      return product
    } catch (error) {
      console.error('Error fetching product:', error)
      return null
    }
  }

  encodeId(numericId) {
    return `gid://shopify/Product/${numericId}`
  }
}

// Funzione globale a livello di window
window.eventFetch = async function (productId, variantId, event) {
  const fetcher = new ShopifyProductFetcher(
    window.token_storefront,
    window.storename
  )
  await fetcher.sendEvent(productId, variantId, event)
}
window.viewModalSearch = async function () {
  GtmDataExtractor.sendViewEvent('gtm-modal-search', {
    event: 'search',
    method: 'modal',
  })
}

//ANCHOR Function for collection handle if it is eliminated from product grid
window.redirectCollectionTrail = function () {
  let urlProductPage = window.location.href
  if (urlProductPage.includes('/collections/')) {
    window.location.href = urlProductPage.replace(/collections\/[^/]+\//, '')
  }
}

class FiltersManagement {
  static abortController = new AbortController()

  static handleRemoveClick(anchorElement) {
    if (!anchorElement || !anchorElement.id) return
    // Sostituisce "remove-" con "tagInput-" nell'ID dell'anchor per ottenere l'ID del checkbox
    const checkboxId = anchorElement.id.replace('remove-', 'tagInput-')
    const checkbox = document.getElementById(checkboxId)
    checkbox.checked = false
    const listItem = anchorElement.closest('li')
    listItem.remove()
    checkbox.checked = false
    let parent = checkbox.closest('li')
    parent.classList.remove('tag--active')
  }

  static getCollectionFilterId() {
    return document
      .querySelector('.collection-section-filters')
      .id.replace('shopify-section-', '')
  }

  static getCurrentUrl() {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('q')) {
      window.savedQueryParam = urlParams.get('q')
    }
    if (urlParams.has('sort_by')) {
      window.savedOrderParams = urlParams.get('sort_by')
    }

    return window.location.href.split('?')[0]
  }

  static getFilters() {
    return new FormData(document.querySelector('.basic-filter-form'))
  }

  static createUrl() {
    let currentUrl = this.getCurrentUrl()
    let searchUrl = new URLSearchParams(this.getFilters())
    if (window.savedQueryParam) {
      searchUrl.set('q', window.savedQueryParam)
    }
    if (window.savedOrderParams) {
      searchUrl.set('sort_by', window.savedOrderParams)
    }

    searchUrl.set('filter.v.availability', '1')

    return `${currentUrl}?${new URLSearchParams(
      searchUrl
    )}&section_id=${this.getCollectionFilterId()}`
  }
  static async fetchFilterDrawer(signal) {
    try {
      let url = this.createUrl()
      let response = await fetch(url, { signal })

      let urlObj = new URL(url)
      urlObj.searchParams.delete('section_id')
      window.history.replaceState({}, document.title, urlObj.toString())
      if (!response.ok) throw new Error(`Errore HTTP: ${response.status}`)
      let doc = new DOMParser().parseFromString(
        await response.text(),
        'text/html'
      )
      return doc
    } catch (error) {
      if (error.name !== 'AbortError')
        console.error('Errore nella fetchFilterDrawer:', error)
      throw error
    }
  }
  static updatePage(completeHtml, arrayIds) {
    for (let i = 0; i < arrayIds.length; i++) {
      const id = arrayIds[i]
      const newHtml = completeHtml.getElementById(id)
      const attualHtml = document.getElementById(id)
      if (newHtml && attualHtml) {
        attualHtml.innerHTML = newHtml.innerHTML
      }
    }
  }
  static updateSidebar(completeHtml) {
    let sidebarHtml = completeHtml.getElementById('FilterDrawer').innerHTML
    const doc = new DOMParser().parseFromString(sidebarHtml, 'text/html')
    doc.querySelectorAll('[id^="SidebarDrawer-"]').forEach((el) => {
      const oldEl = document.getElementById(el.id)
      if (oldEl) {
        oldEl.innerHTML = el.innerHTML

        const collapsibleContent = oldEl.querySelector(
          '.collapsible-content__inner'
        )
        if (
          collapsibleContent &&
          oldEl.style.height &&
          oldEl.style.height != '0px' &&
          collapsibleContent.offsetHeight
        ) {
          oldEl.style.height = collapsibleContent.offsetHeight + 'px'
        }
      }
    })
  }
  static startLoading() {
    document
      .querySelectorAll('.count-filter')
      .forEach((el) => (el.innerHTML = ''))
    document
      .querySelector('.collection-section-filters')
      ?.classList.add('filter-loading')
    document.getElementById('full-page-loader').style.display = 'flex'
  }

  static stopLoading() {
    document
      .querySelector('.collection-section-filters')
      ?.classList.remove('filter-loading')
    document.getElementById('full-page-loader').style.display = 'none'
  }

  static updateButtonFilterDrawner(completeHtml) {
    let filtersCount = completeHtml
      .getElementById('FilterDrawerButton')
      .getAttribute('data-filters-count')
    if (filtersCount != '0' && filtersCount != '1') {
      document
        .getElementById('FilterDrawerButton')
        .classList.add('btn--tertiary-active')
      document.getElementById('activeFilterCounter').innerHTML = `(${
        parseInt(filtersCount, 10) - 1
      })`
    } else {
      document
        .getElementById('FilterDrawerButton')
        .classList.remove('btn--tertiary-active')
      document.getElementById('activeFilterCounter').innerHTML = ''
    }
  }

  //ORIGINAL THEME BEHAVIOUR
  static async updateContent() {
    this.abortController.abort()
    this.abortController = new AbortController()
    const { signal } = this.abortController

    try {
      FiltersManagement.startLoading()
      let completeHtml = await this.fetchFilterDrawer(signal)
      FiltersManagement.updateSidebar(completeHtml)
      FiltersManagement.updatePage(completeHtml, [
        'ajaxGridContent',
        'pagination-section',
        'productCount',
      ])
      FiltersManagement.updateButtonFilterDrawner(completeHtml)
      FiltersManagement.stopLoading()
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Errore:', error)
      }
    }
  }

  //NEW GRID BEHAVIOUR
  //   static async updateContent() {
  //   this.abortController.abort()
  //   this.abortController = new AbortController()
  //   const { signal } = this.abortController

  //   try {
  //     FiltersManagement.startLoading()
  //     let completeHtml = await this.fetchFilterDrawer(signal)
  //     FiltersManagement.updateSidebar(completeHtml)
  //     FiltersManagement.updatePage(completeHtml, [
  //       'authenticFiltersCount',
  //       'pagination-section',
  //     ])
  //     let productCount =  completeHtml.getElementById('authenticFiltersCount').getAttribute('data-products-count') 
  //     document.getElementById('productCount').innerHTML = productCount
  //     FiltersManagement.updateButtonFilterDrawner(completeHtml)
  //     FiltersManagement.stopLoading()
  //     window.syncPlpHeights();
  //   } catch (error) {
  //     if (error.name !== 'AbortError') {
  //       console.error('Errore:', error)
  //     }
  //   }
  // }

  static manageActiveClass(evt) {
    let el = evt.target
    let parent = el.closest('li')
    if (parent.classList.contains('tag--active')) {
      parent.classList.remove('tag--active')
    } else {
      parent.classList.add('tag--active')
    }
  }
  static async managePriceRange(setting) {
    let priceRangeContainer = document.querySelector('.price-range')
    if (priceRangeContainer) {
      new theme.PriceRange(priceRangeContainer, {
        onChange: (formData) => {
          FiltersManagement.init(setting)
        },
        onUpdate: function (values) {
          document.querySelector(
            '.price-range__input.price-range__input-min'
          ).value = values[0]
          document.querySelector(
            '.price-range__input.price-range__input-max'
          ).value = values[1]
        },
        step: 10,
      })
    }
  }

    static orderFilter() {
    document.querySelectorAll('.sort_by').forEach((element) => {
      element.addEventListener('click', (event) => {
        const sortValue = event.currentTarget.getAttribute('data-sortvalue')

        const url = new URL(window.location)
        url.searchParams.set('sort_by', sortValue)
        window.history.pushState({}, '', url)

        document
          .querySelectorAll('.sort_by')
          .forEach((el) => el.classList.remove('red-text'))
        event.currentTarget.classList.add('red-text')

        const sortEvent = new CustomEvent('sortChanged', {
          detail: { sortValue },
        })
        document.dispatchEvent(sortEvent)
      })
    })
  }

  static async init(setting) {
    await FiltersManagement.updateContent()
    await FiltersManagement.managePriceRange(setting)
    setting()
    // FiltersManagement.orderFilter()
    window.earlyAccessInit()
  }
}

function updateEarlyAccessPrices(isActive, handle, couponCode) {
  if (!isActive) return

  const urlMatch = window.location.href.includes(handle)
  const storedCode = localStorage.getItem('early_access')
  const codeMatch = storedCode === couponCode

  if (!urlMatch && !codeMatch) return
  console.log('early access activated')
  document.dispatchEvent(new CustomEvent('cart:build'))
  document.querySelectorAll('.grid-product__price').forEach((div) => {
    const price = parseInt(div.dataset.earlyAccessPrice, 10)
    const omnibus = parseInt(div.dataset.earlyAccessOmnibus, 10)
    const currency = div.dataset.currency || ''

    if (!isNaN(price) && !isNaN(omnibus)) {
      const formattedPrice = (price / 100).toFixed(2).replace('.', ',')
      const formattedOmnibus = (omnibus / 100).toFixed(2).replace('.', ',')

      div.innerHTML = `
<span class="custom-price custom-saving-color">
  ${currency}${formattedPrice}
  <span class="custom-full-price">
    ${currency}${formattedOmnibus}
  </span>
  <span class="custom-discount">
    ${window.best_previous_price} ${currency}${formattedOmnibus}
  </span>
</span>`
    }
  })
}

function checkDiscountCode(handle, discountCode) {
  if (window.location.href.includes(handle)) return

  const storedCode = localStorage.getItem('early_access')
  if (storedCode !== discountCode) return

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      console.log('cart', cart)
      const codeInCart = cart.discount_codes.some(
        (dc) => dc.code === discountCode
      )
      if (!codeInCart) {
        localStorage.removeItem('early_access')
        console.log('removed')
        window.EMD.emit('early_access_removed', {
          detail: 'removed',
        })
      }
    })
    .catch((err) => console.error('Cart fetch error:', err))
}
